import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
import { Typography, Button } from 'components'

const Container = styled.div`
  width: 100%;
  margin-bottom: 25px;
`
const CategoryRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`
const Tag = styled((props) => <Button {...props} />)`
  border: 1px solid #253e87;
  color: #253e87;
  border-radius: 20px;
  height: 30px;
  padding: 0 18px;
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: transparent;
  cursor: default;
`

const Category = (props) => {
  // console.log('props', props)
  const { course, courseCategories, getCourseCategories } = props
  const { categoryId, subCategoryId } = course
  const category = courseCategories.find(({ id }) => id === categoryId)
  const subCategory = category && category.subcategories.find(({ id }) => id === subCategoryId)

  useEffect(() => {
    getCourseCategories()
  }, [getCourseCategories])

  return (
    <ErrorBoundary>
      <Container>
        <Typography
          id="course.detail.courseCategory"
          color="primary1"
          fontSize="text-sm"
          fontWeight={600}
          margin="0 0 15px 0"
        >
          Course Category
        </Typography>
        <CategoryRow>
          <Tag nowrap>{category?.name}</Tag>
          <Tag nowrap>{subCategory?.name}</Tag>
        </CategoryRow>
      </Container>
    </ErrorBoundary>
  )
}

const mapState = ({ CourseCategories: { courseCategories } }) => ({
  courseCategories,
})
const mapDispatch = ({ CourseCategories: { getCourseCategories } }) => ({ getCourseCategories })

export default connect(mapState, mapDispatch)(Category)
